import React from 'react';

const ManageProduct = () => {
  return <div></div>;
};

export default ManageProduct;
